import { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import swal from "sweetalert2";
import NewsLetter from '../components/NewsLetter';

const contactInfo = [
    {
        icon: (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" />
            </svg>
        ),
        title: "Our Address",
        lines: ["BHARAT LAW HOUSE PVT. LTD.", "T-1/95, Mangolpuri Industrial Area, Phase-I", "New Delhi-110 083"]
    },
    {
        icon: (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
        ),
        title: "Our Phones",
        lines: ["Phones: 2791 0001-03", "Mobile: 98102 67553"]
    },
    {
        icon: (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" />
            </svg>
        ),
        title: "Our Email",
        lines: ["sales@bharatlaws.com", "ca.dbco@gmail.com"]
    },
];

export default function ContactUs() {
    const form = useRef();
    const [sending, setSending] = useState(false);

    const sendEmail = e => {
        e.preventDefault();
        setSending(true);
        emailjs.sendForm('service_gfykn6i', 'template_iy1pb0b', e.target, 'HccoOtZS6GHw-N-m6')
            .then(() => { }, err => console.log(err.text))
            .finally(() => setSending(false));
        e.target.reset();
        swal('Message Sent!', 'We\'ll get back to you shortly.', 'success');
    };

    const inputStyle = {
        width: "100%", padding: "14px 18px", borderRadius: 12,
        border: "1.5px solid #f0d0c8", background: "#fff8f8",
        fontFamily: "'Nunito Sans',sans-serif", fontSize: 14,
        outline: "none", color: "#1a0a08", transition: "border-color 0.2s",
        display: "block"
    };
    const focusRed = e => e.target.style.borderColor = "#C0392B";
    const blurRed = e => e.target.style.borderColor = "#f0d0c8";

    return (
        <div className="contact-page" style={{ background: "#FDF5F5" }}>
            <style>{`
                @media (max-width: 1024px) {
                    .contact-section { padding: 40px 24px !important; }
                    .contact-grid { grid-template-columns: 1fr !important; gap: 40px !important; }
                    .contact-form-inner-grid { grid-template-columns: 1fr !important; }
                    .contact-map { height: 260px !important; }
                }
            `}</style>
            {/* ── Map ──────────────────────────────────────────────────── */}
            <div className="contact-map" style={{ height: 340, overflow: "hidden", position: "relative" }}>
                <div style={{
                    position: "absolute", bottom: 0, left: 0, right: 0, height: 60,
                    background: "linear-gradient(to bottom, transparent, #FDF5F5)",
                    zIndex: 2, pointerEvents: "none"
                }} />
                <iframe
                    src="https://maps.google.com/maps?q=Bharat+Law+House,+Mangolpuri+Industrial+Area,+New+Delhi&t=&z=15&ie=UTF8&iwloc=&output=embed"
                    style={{ border: 0, width: "100%", height: "100%", filter: "sepia(0.2) hue-rotate(-10deg) saturate(0.9)" }}
                    allowFullScreen title="Bharat Law House Location"
                />
            </div>

            {/* ── Contact section ───────────────────────────────────────── */}
            <section className="contact-section" style={{ padding: "80px 72px" }}>
                <div className="contact-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1.5fr", gap: 60, maxWidth: 1100, margin: "0 auto", alignItems: "start" }}>

                    {/* Left: info panel */}
                    <div style={{
                        background: "linear-gradient(135deg, #6B1A1A 0%, #521010 60%, #611515 100%)",
                        borderRadius: 24, padding: 40, position: "relative", overflow: "hidden",
                        boxShadow: "0 16px 48px rgba(192,57,43,0.3)"
                    }}>
                        {/* Dot grid */}
                        <div style={{ position: "absolute", inset: 0, backgroundImage: "radial-gradient(circle, rgba(255,255,255,0.1) 1.5px, transparent 1.5px)", backgroundSize: "24px 24px", pointerEvents: "none" }} />
                        {/* Glow */}
                        <div style={{ position: "absolute", top: -40, right: -40, width: 200, height: 200, borderRadius: "50%", background: "radial-gradient(circle, rgba(232,82,58,0.2), transparent 70%)", pointerEvents: "none" }} />

                        <div style={{ position: "relative", zIndex: 1 }}>
                            <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.2)", borderRadius: 50, padding: "5px 14px", marginBottom: 20 }}>
                                <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#F4A48A" }} />
                                <span style={{ color: "#F4A48A", fontSize: 11, fontWeight: 800, letterSpacing: "0.1em" }}>GET IN TOUCH</span>
                            </div>
                            <h3 style={{ fontFamily: "'Playfair Display',serif", fontSize: 28, fontWeight: 800, color: "white", marginBottom: 8, lineHeight: 1.15 }}>We'd Love to<br /><span style={{ color: "#F4A48A", fontStyle: "italic" }}>Hear from You</span></h3>
                            <p style={{ color: "rgba(255,255,255,0.6)", fontSize: 14, lineHeight: 1.7, marginBottom: 36 }}>If you are interested in working with us or have any queries, please get in touch.</p>

                            <div style={{ display: "flex", flexDirection: "column", gap: 28 }}>
                                {contactInfo.map((c, i) => (
                                    <div key={i} style={{ display: "flex", gap: 16, alignItems: "flex-start" }}>
                                        <div style={{
                                            width: 44, height: 44, borderRadius: 12, flexShrink: 0,
                                            background: "rgba(192,57,43,0.35)", border: "1px solid rgba(232,82,58,0.4)",
                                            display: "flex", alignItems: "center", justifyContent: "center",
                                            color: "#F4A48A"
                                        }}>{c.icon}</div>
                                        <div>
                                            <div style={{ color: "rgba(255,255,255,0.5)", fontSize: 11, fontWeight: 700, letterSpacing: "0.08em", marginBottom: 4 }}>{c.title.toUpperCase()}</div>
                                            {c.lines.map((l, j) => (
                                                <div key={j} style={{ color: "rgba(255,255,255,0.85)", fontSize: 13, lineHeight: 1.7, fontWeight: j === 0 ? 600 : 400 }}>{l}</div>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Social icons */}
                            <div style={{ display: "flex", gap: 10, marginTop: 36 }}>
                                {["📘", "🐦", "📸", "▶️"].map(icon => (
                                    <div key={icon} style={{
                                        width: 38, height: 38, borderRadius: 10,
                                        background: "rgba(255,255,255,0.08)", border: "1px solid rgba(192,57,43,0.3)",
                                        display: "flex", alignItems: "center", justifyContent: "center",
                                        fontSize: 16, cursor: "pointer", transition: "all 0.2s"
                                    }}
                                        onMouseEnter={e => { e.currentTarget.style.background = "rgba(192,57,43,0.3)"; }}
                                        onMouseLeave={e => { e.currentTarget.style.background = "rgba(255,255,255,0.08)"; }}
                                    >{icon}</div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Right: form */}
                    <div style={{
                        background: "white", borderRadius: 24,
                        border: "1.5px solid #f0d0c8", padding: 40,
                        boxShadow: "0 4px 24px rgba(192,57,43,0.08)",
                        overflow: "hidden", position: "relative"
                    }}>
                        <div style={{ height: 3, background: "linear-gradient(90deg, #C0392B, #E8523A)", margin: "-40px -40px 32px" }} />

                        <div style={{ marginBottom: 28 }}>
                            <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(192,57,43,0.08)", border: "1px solid rgba(192,57,43,0.2)", borderRadius: 50, padding: "5px 14px", marginBottom: 14 }}>
                                <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#C0392B" }} />
                                <span style={{ color: "#C0392B", fontSize: 11, fontWeight: 800, letterSpacing: "0.1em" }}>CONTACT US</span>
                            </div>
                            <h3 style={{ fontFamily: "'Playfair Display',serif", fontSize: 28, fontWeight: 800, color: "#1a0a08", lineHeight: 1.15 }}>
                                Send Us a <span style={{ color: "#C0392B", fontStyle: "italic" }}>Message</span>
                            </h3>
                        </div>

                        <form ref={form} onSubmit={sendEmail} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                            <input type="hidden" name="dzToDo" defaultValue="Contact" />

                            <div className="contact-form-inner-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
                                <div>
                                    <label style={{ display: "block", fontSize: 12, fontWeight: 700, color: "#7a5550", marginBottom: 6 }}>Full Name</label>
                                    <input required type="text" name="dzName" placeholder="Your full name" style={inputStyle} onFocus={focusRed} onBlur={blurRed} />
                                </div>
                                <div>
                                    <label style={{ display: "block", fontSize: 12, fontWeight: 700, color: "#7a5550", marginBottom: 6 }}>Email Address</label>
                                    <input required type="email" name="dzEmail" placeholder="you@email.com" style={inputStyle} onFocus={focusRed} onBlur={blurRed} />
                                </div>
                            </div>

                            <div>
                                <label style={{ display: "block", fontSize: 12, fontWeight: 700, color: "#7a5550", marginBottom: 6 }}>Phone Number</label>
                                <input required type="text" name="dzPhoneNumber" placeholder="+91 98xxx xxxxx" style={inputStyle} onFocus={focusRed} onBlur={blurRed} />
                            </div>

                            <div>
                                <label style={{ display: "block", fontSize: 12, fontWeight: 700, color: "#7a5550", marginBottom: 6 }}>Message</label>
                                <textarea required name="dzMessage" rows={5} placeholder="Tell us how we can help..." style={{ ...inputStyle, resize: "vertical" }} onFocus={focusRed} onBlur={blurRed} />
                            </div>

                            <button
                                type="submit"
                                disabled={sending}
                                style={{
                                    padding: "15px", fontSize: 15, fontWeight: 700,
                                    background: sending ? "#c07070" : "linear-gradient(135deg, #C0392B, #96221A)",
                                    color: "white", border: "none", borderRadius: 12,
                                    cursor: sending ? "not-allowed" : "pointer",
                                    fontFamily: "'Nunito Sans',sans-serif",
                                    boxShadow: "0 4px 18px rgba(192,57,43,0.3)",
                                    transition: "all 0.2s"
                                }}
                            >
                                {sending ? (
                                    <span style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
                                        <span style={{ width: 16, height: 16, borderRadius: "50%", border: "2px solid rgba(255,255,255,0.3)", borderTopColor: "white", display: "inline-block", animation: "spin 0.8s linear infinite" }} />
                                        Sending...
                                    </span>
                                ) : "Send Message →"}
                            </button>
                        </form>
                    </div>
                </div>
            </section>

            <NewsLetter />
        </div>
    );
}